import { render } from "./StudentClassText.vue?vue&type=template&id=624f8e63&scoped=true&ts=true"
import script from "./StudentClassText.vue?vue&type=script&lang=ts"
export * from "./StudentClassText.vue?vue&type=script&lang=ts"

import "./StudentClassText.vue?vue&type=style&index=0&id=624f8e63&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624f8e63"]])

export default __exports__